import gql from 'graphql-tag';

export const createFlatfileImportSession = gql`
  mutation FlatfileImportSession($input: CreateFlatfileImportSession!) {
    createFlatfileImportSession(input: $input) {
      url
    }
  }
`;
